export const history: { navigate: any, location: any } = { location: null, navigate: null };